// extracted by mini-css-extract-plugin
export default {"reg":"styles_reg__UU1K5","body":"styles_body__xdUNP","card":"styles_card__uzwqa","options":"styles_options__Y+8xn"};